import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWordmark = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 129.67 27.12",
	width: 129.67,
	height: 29.199,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			className: "cls-1",
			d: "M0,25.47V3.56A2.52,2.52,0,0,1,.48,2.08a2.63,2.63,0,0,1,1.26-.92,2.6,2.6,0,0,1,1.56,0,2.54,2.54,0,0,1,1.26.92l6.23,8.54a1.92,1.92,0,0,1,.3.63,2.26,2.26,0,0,1,0,.82,2.07,2.07,0,0,1-.29.76,1.89,1.89,0,0,1-.56.6,2.19,2.19,0,0,1-.74.35,2.59,2.59,0,0,1-.47.05l-.35,0A2.26,2.26,0,0,1,8,13.52a1.45,1.45,0,0,1-.41-.37L4.33,8.69V25.48A2.18,2.18,0,0,1,3.67,27a2.15,2.15,0,0,1-1.5.61A2.17,2.17,0,0,1,0,25.48Z",
			transform: "translate(0 -1.04)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			className: "cls-1",
			d: "M22.12,3.12V25a2.52,2.52,0,0,1-3.3,2.4,2.5,2.5,0,0,1-1.26-.91L11.32,18a2.07,2.07,0,0,1-.29-.62,2.26,2.26,0,0,1,0-.82,2.19,2.19,0,0,1,.29-.77,2.11,2.11,0,0,1,1.3-.94,1.89,1.89,0,0,1,.47-.06,2.07,2.07,0,0,1,.35,0,1.91,1.91,0,0,1,.76.29,1.42,1.42,0,0,1,.41.36l3.21,4.46V3.12A2.17,2.17,0,0,1,20,1a2.19,2.19,0,0,1,1.51.61A2.14,2.14,0,0,1,22.12,3.12Z",
			transform: "translate(0 -1.04)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			className: "cls-1",
			d: "M36.05,28.16c-5.83,0-9.77-3.78-9.77-9.42s4.06-10,9.64-10S45,12.34,45,17.91A1.52,1.52,0,0,1,44.56,19a1.6,1.6,0,0,1-1.07.45H30.68l0,.36a5.38,5.38,0,0,0,5.52,5.13,4.85,4.85,0,0,0,4.65-2.41,1.45,1.45,0,0,1,.54-.53,1.36,1.36,0,0,1,.74-.19h.16l.48,0a1.56,1.56,0,0,1,.69.25,1.69,1.69,0,0,1,.49.54,1.51,1.51,0,0,1,.18.72,1.47,1.47,0,0,1-.18.71C42.49,26.7,39.68,28.16,36.05,28.16Zm-.17-16.29c-2.71,0-4.46,1.59-5.09,4.6l-.09.41h10l0-.37A4.65,4.65,0,0,0,35.88,11.87Z",
			transform: "translate(0 -1.04)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			className: "cls-1",
			d: "M57.75,28.16a9.27,9.27,0,0,1-9.68-9.68,9.29,9.29,0,0,1,9.68-9.72,9.32,9.32,0,0,1,9.73,9.73C67.48,24.22,63.48,28.16,57.75,28.16Zm0-16.17c-3.22,0-5.14,2.43-5.14,6.49s1.92,6.43,5.14,6.43,5.18-2.4,5.18-6.43S61,12,57.75,12Z",
			transform: "translate(0 -1.04)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			className: "cls-1",
			d: "M73.41,27.64a2.51,2.51,0,0,1-1-.2A2.55,2.55,0,1,1,76,25.08a2.6,2.6,0,0,1-.75,1.81,2.56,2.56,0,0,1-.83.55,2.53,2.53,0,0,1-1,.2Z",
			transform: "translate(0 -1.04)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			className: "cls-1",
			d: "M83.75,27.64a2.37,2.37,0,0,1-2.36-2.36V9.48a2.36,2.36,0,0,1,.69-1.67,2.4,2.4,0,0,1,1.67-.69,2.36,2.36,0,0,1,2.36,2.36v15.8a2.3,2.3,0,0,1-.18.9,2.32,2.32,0,0,1-1.28,1.28,2.3,2.3,0,0,1-.9.18Zm-10-22.73A1.9,1.9,0,0,1,73,4.75a2,2,0,0,1-.65-.43,2,2,0,0,1-.59-1.43,1.84,1.84,0,0,1,.13-.69,1.85,1.85,0,0,1,.39-.58,1.82,1.82,0,0,1,1.27-.52H94.07a1.8,1.8,0,0,1,.69.13,1.91,1.91,0,0,1,.58.39,1.85,1.85,0,0,1,.39.58,1.81,1.81,0,0,1,.14.69,2,2,0,0,1-.6,1.42,2,2,0,0,1-1.42.6Z",
			transform: "translate(0 -1.04)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			className: "cls-1",
			d: "M99.33,28.12c-3.78,0-6.06-1.85-6.06-4.93s2.09-4.7,7-5.68l5.49-1.08v-.71c0-2.41-1.34-3.78-3.67-3.78a3.84,3.84,0,0,0-3.55,2,2,2,0,0,1-.8.8,2,2,0,0,1-.94.23h-.16a1.93,1.93,0,0,1-1.78-2,1.89,1.89,0,0,1,.32-1c1.44-2.08,3.9-3.18,7.1-3.18,5,0,7.82,2.49,7.82,7v9.85a2.11,2.11,0,0,1-.45,1.34,2,2,0,0,1-1,.64,2,2,0,0,1-1.19,0,2.05,2.05,0,0,1-1-.72,2,2,0,0,1-.36-1.13V24.62c0-.12-.19-.16-.27,0C104.81,26.69,102,28.12,99.33,28.12Zm2.4-8.43c-2.12.45-4.12.88-4.12,3.09,0,1.48,1.14,2.4,3,2.4a5.15,5.15,0,0,0,5.15-5.49v-.88Z",
			transform: "translate(0 -1.04)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			className: "cls-1",
			d: "M115.62,27.64a1.76,1.76,0,0,1-1-.28,1.66,1.66,0,0,1-.66-.73,1.81,1.81,0,0,1-.18-1,1.87,1.87,0,0,1,.37-.92l5.11-6.52-4.62-6.08a1.9,1.9,0,0,1-.36-.92,1.82,1.82,0,0,1,.19-1,1.77,1.77,0,0,1,.66-.72,1.74,1.74,0,0,1,.94-.27h.47a1.89,1.89,0,0,1,.81.19A1.93,1.93,0,0,1,118,10l3.77,5.13L125.63,10a1.72,1.72,0,0,1,.64-.53,1.6,1.6,0,0,1,.8-.19,1.72,1.72,0,0,1,1,.26,1.8,1.8,0,0,1,.5,2.61L124,18l5.25,6.73a1.82,1.82,0,0,1,.37.92,1.72,1.72,0,0,1-.17,1,1.77,1.77,0,0,1-1.61,1h-.45a1.85,1.85,0,0,1-.8-.19,1.79,1.79,0,0,1-.64-.52l-4.46-5.83-4.46,5.86a1.74,1.74,0,0,1-.65.52,1.71,1.71,0,0,1-.8.19Z",
			transform: "translate(0 -1.04)"
		})
	]
});
export { SvgWordmark as ReactComponent };
